(function() {
  'use strict';

  var settings = window.GWP_SETTINGS;
  if (!settings || !settings.enabled || !settings.variantId) {
    return;
  }

  var isSyncing = false;
  var pendingSyncPromise = null;
  var giftVariantId = String(settings.variantId);
  var checkoutFormSelector = '#CartDrawerForm, #CartPageForm';

  // Same sellable variant: gift is a separate cart line (_gwp property only).
  // Paid lines of the same variant are never modified or removed.
  //
  // Pricing is handled entirely by an Automatic discount in Shopify admin
  // (Buy X Get Y). This script never applies discounts itself - Shopify
  // evaluates the automatic discount against cart contents and the result
  // is reflected natively in cart.total_price / cart.total_discounts, which
  // flows through to checkout with no extra code required.
  function isGiftLine(item) {
    return item.properties && String(item.properties._gwp) === 'true';
  }

  function getEligibleQuantity(cart) {
    return cart.items
      .filter(function(item) { return !isGiftLine(item); })
      .reduce(function(sum, item) { return sum + item.quantity; }, 0);
  }

  function getGiftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  function cartNeedsGiftSync(cart) {
    var giftLines = getGiftLines(cart);
    var eligibleQuantity = getEligibleQuantity(cart);
    var qualifies = eligibleQuantity >= settings.minQuantity;

    if (giftLines.length > 1) {
      return true;
    }

    if (qualifies && giftLines.length === 0) {
      return true;
    }

    if (!qualifies && giftLines.length > 0) {
      return true;
    }

    return false;
  }

  function fetchCart() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart)
      ? window.theme.routes.cart
      : '/cart.js';
    url += (url.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now();

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(response) { return response.json(); });
  }

  function postJson(url, data) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    }).then(function(response) { return response.json(); });
  }

  // Always adds qty 1 on a new line, even when paid qty of same variant is already 2+.
  function addGift() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cartAdd)
      ? window.theme.routes.cartAdd
      : '/cart/add.js';

    return postJson(url, {
      id: parseInt(giftVariantId, 10),
      quantity: 1,
      properties: { _gwp: 'true' }
    });
  }

  function changeLine(key, quantity) {
    var url = (window.theme && window.theme.routes && window.theme.routes.cartChange)
      ? window.theme.routes.cartChange
      : '/cart/change.js';

    return postJson(url, { id: key, quantity: quantity });
  }

  // Only removes _gwp lines; never touches paid lines of the gift variant.
  function removeGiftLines(giftLines) {
    return giftLines.reduce(function(chain, line) {
      if (!isGiftLine(line)) {
        return chain;
      }
      return chain.then(function() { return changeLine(line.key, 0); });
    }, Promise.resolve());
  }

  function updateMessages(cart, eligibleQuantity, giftLines) {
    var messageEls = document.querySelectorAll('[data-gwp-message]');
    if (!messageEls.length) {
      return;
    }

    var qualifies = eligibleQuantity >= settings.minQuantity;
    var remaining = settings.minQuantity - eligibleQuantity;
    var text = '';

    if (qualifies && giftLines.length > 0) {
      text = settings.messageUnlocked || '';
    } else if (!qualifies && remaining > 0) {
      text = (settings.messageProgress || '')
        .replace('[count]', remaining)
        .replace('[items]', remaining === 1 ? 'item' : 'items');
    }

    messageEls.forEach(function(el) {
      if (text) {
        el.textContent = text;
        el.classList.remove('hide');
      } else {
        el.textContent = '';
        el.classList.add('hide');
      }
    });
  }

  function refreshCartUI() {
    // Re-fetches cart.ajax.liquid, which re-runs gwp-cart-totals.liquid
    // server-side against the real (post-automatic-discount) cart state.
    document.dispatchEvent(new CustomEvent('cart:build'));

    if (window.icart && typeof window.icart.refreshCart === 'function') {
      window.icart.refreshCart();
    }

    document.dispatchEvent(new CustomEvent('gwp:synced'));
  }

  function syncGiftWithPurchase(options) {
    options = options || {};

    if (isSyncing && pendingSyncPromise) {
      return pendingSyncPromise;
    }

    isSyncing = true;

    pendingSyncPromise = fetchCart()
      .then(function(cart) {
        var giftLines = getGiftLines(cart);

        if (giftLines.length > 1) {
          return removeGiftLines(giftLines.slice(1)).then(fetchCart);
        }

        return cart;
      })
      .then(function(cart) {
        var giftLines = getGiftLines(cart);
        var eligibleQuantity = getEligibleQuantity(cart);
        var qualifies = eligibleQuantity >= settings.minQuantity;

        if (qualifies && giftLines.length === 0) {
          return addGift().then(function(result) {
            if (result.status === 422) {
              console.warn('GWP: could not add gift', result.description || result.message);
            }
          });
        }

        if (!qualifies && giftLines.length > 0) {
          return removeGiftLines(giftLines);
        }
      })
      .then(function() {
        return fetchCart();
      })
      .then(function(updatedCart) {
        updateMessages(
          updatedCart,
          getEligibleQuantity(updatedCart),
          getGiftLines(updatedCart)
        );

        if (!options.skipUIRefresh) {
          refreshCartUI();
        }

        return updatedCart;
      })
      .catch(function(err) {
        console.warn('GWP sync failed', err);
      })
      .finally(function() {
        isSyncing = false;
        pendingSyncPromise = null;
      });

    return pendingSyncPromise;
  }

  function submitCheckoutForm(form, submitter) {
    form.dataset.gwpCheckoutBypass = 'true';

    if (submitter) {
      submitter.disabled = false;
      submitter.classList.remove('btn--loading');
      submitter.click();
      return;
    }

    form.submit();
  }

  function handleCheckoutSubmit(evt) {
    var form = evt.target;

    if (!form.matches || !form.matches(checkoutFormSelector)) {
      return;
    }

    if (form.dataset.gwpCheckoutBypass === 'true') {
      return;
    }

    var submitter = evt.submitter;
    if (!submitter || submitter.name !== 'checkout') {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();

    submitter.disabled = true;
    submitter.classList.add('btn--loading');

    syncGiftWithPurchase({ skipUIRefresh: true })
      .then(function() {
        submitCheckoutForm(form, submitter);
      })
      .catch(function() {
        submitCheckoutForm(form, submitter);
      });
  }

  function bindCheckoutGuard() {
    document.addEventListener('submit', handleCheckoutSubmit, true);

    document.addEventListener('click', function(evt) {
      var btn = evt.target.closest('[name="checkout"], .cart__checkout');
      if (!btn || btn.disabled) {
        return;
      }

      var form = btn.closest('form');
      if (!form || form.matches(checkoutFormSelector)) {
        return;
      }

      if (form.dataset.gwpCheckoutBypass === 'true') {
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();

      btn.disabled = true;
      btn.classList.add('btn--loading');

      syncGiftWithPurchase({ skipUIRefresh: true })
        .then(function() {
          form.dataset.gwpCheckoutBypass = 'true';
          btn.disabled = false;
          btn.classList.remove('btn--loading');
          if (form.requestSubmit) {
            form.requestSubmit(btn);
          } else {
            btn.click();
          }
        })
        .catch(function() {
          form.dataset.gwpCheckoutBypass = 'true';
          btn.disabled = false;
          btn.classList.remove('btn--loading');
          if (form.requestSubmit) {
            form.requestSubmit(btn);
          } else {
            btn.click();
          }
        });
    }, true);
  }

  document.addEventListener('cart:updated', syncGiftWithPurchase);
  document.addEventListener('ajaxProduct:added', syncGiftWithPurchase);
  document.addEventListener('icart:updated', syncGiftWithPurchase);
  document.addEventListener('icart:refresh', syncGiftWithPurchase);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncGiftWithPurchase();
      bindCheckoutGuard();
    });
  } else {
    syncGiftWithPurchase();
    bindCheckoutGuard();
  }
})();
